/* tslint:disable */
/* eslint-disable */
/**
 * Berichtsmanagement-common
 * Berichte verwalten
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MaschinenGruppe
 */
export interface MaschinenGruppe {
    /**
     * 
     * @type {string}
     * @memberof MaschinenGruppe
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof MaschinenGruppe
     */
    bezeichnung: string;
    /**
     * 
     * @type {string}
     * @memberof MaschinenGruppe
     */
    gueltigVon: string;
    /**
     * 
     * @type {string}
     * @memberof MaschinenGruppe
     */
    gueltigBis?: string;
}

/**
 * Check if a given object implements the MaschinenGruppe interface.
 */
export function instanceOfMaschinenGruppe(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "bezeichnung" in value;
    isInstance = isInstance && "gueltigVon" in value;

    return isInstance;
}

export function MaschinenGruppeFromJSON(json: any): MaschinenGruppe {
    return MaschinenGruppeFromJSONTyped(json, false);
}

export function MaschinenGruppeFromJSONTyped(json: any, ignoreDiscriminator: boolean): MaschinenGruppe {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'bezeichnung': json['bezeichnung'],
        'gueltigVon': json['gueltigVon'],
        'gueltigBis': !exists(json, 'gueltigBis') ? undefined : json['gueltigBis'],
    };
}

export function MaschinenGruppeToJSON(value?: MaschinenGruppe | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'bezeichnung': value.bezeichnung,
        'gueltigVon': value.gueltigVon,
        'gueltigBis': value.gueltigBis,
    };
}

